import { API } from "aws-amplify";

import { getAPIReq } from "./authLib";

const OauthCallback = async (searchParams) => {
  const req = await getAPIReq();
  return API.get("HublyAPI", `/oauth/callback/${searchParams}`, req);
};
export default OauthCallback;
